import { AttributionFooter } from "@/components/shared/attribution-footer";
import { SidebarProvider } from "./SidebarContext";
import { TopNav } from "./TopNav";

function DashboardLayoutInner({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <TopNav />

      {/* Scrollable content */}
      <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
        <div className="mx-auto max-w-screen-2xl">{children}</div>
      </main>
      <AttributionFooter />
    </div>
  );
}

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <DashboardLayoutInner>{children}</DashboardLayoutInner>
    </SidebarProvider>
  );
}
